import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  TypedUseSelectorHook,
  useSelector as rawUseSelector
} from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import type { Action, Dispatch, StoreEnhancer } from 'redux';

import { createPersistenceEnhancer } from 'ccs-ui-components';
import ImportJourneySummaryReducer from './reducer/ImportJourneySummaryReducer';
import filterJourneyReducer from '../modules/journey-list/JourneyListFilterReducer';
import { rootSaga } from './sagas/rootSaga';

const sagaMiddleware = createSagaMiddleware();

export const reducer = combineReducers({
  ImportJourneySummaryReducer,
  filterJourneyReducer
});

/**
 * Application store responsible for state management
 */
export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false }).concat(sagaMiddleware),
  enhancers: (getDefaultEnhancers) =>
    getDefaultEnhancers().concat(
      createPersistenceEnhancer<ReturnType<typeof reducer>>({
        persistedKeys: ['filterJourneyReducer'],
        storageKey: 'JOURNEY_DESIGNER_FILTER_STATE',
      }) as StoreEnhancer
    )
});

sagaMiddleware.run(rootSaga);

export type AppDispatch = Dispatch<Action<string>>;
export type RootState = ReturnType<typeof store.getState>;
export const useSelector: TypedUseSelectorHook<RootState> = rawUseSelector;
